module.exports = __webpack_public_path__ + "img/logo2.8b211ce2.png";